export default "__VITE_ASSET__CwosUhU6__"